import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/sections/HeroSection';
import TrustBar from '../../components/sections/TrustBar';
import ServicesOverview from '../../components/sections/ServicesOverview';
import AIAnswerBlock from '../../components/sections/AIAnswerBlock';
import ProcessSection from '../../components/sections/ProcessSection';
import WhyChooseUsSection from '../../components/sections/WhyChooseUsSection';
import ServiceAreasSection from '../../components/sections/ServiceAreasSection';
import SocialProofSection from '../../components/sections/SocialProofSection';
import FAQSection from '../../components/sections/FAQSection';
import FinalCTASection from '../../components/sections/FinalCTASection';

const aboutTrustItems = [
  { value: 'Est. 2003', label: 'Founded as Polished Concrete Images', icon: 'ri-history-line' },
  { value: '2011', label: 'Expanded & Rebranded to Polished Concrete Plus', icon: 'ri-refresh-line' },
  { value: '5 States', label: 'MN · IA · WI · ND · SD', icon: 'ri-map-2-line' },
  { value: 'Certified', label: 'Concrete Construction Managers', icon: 'ri-award-fill' },
];

const aboutValues = [
  {
    image: 'https://public.readdy.ai/ai/img_res/a65cff83c33fd99b0279dfeeb910b653.jpg',
    title: 'Craftsmanship First',
    description: 'Every project is approached with the same care and detail — whether a single-room residential floor or a large commercial facility anywhere across Minnesota.',
    href: '/about',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=certified%20concrete%20installation%20team%20professional%20workers%20in%20commercial%20building%20interior%20coordinating%20floor%20project%20industrial%20setting%20teamwork%20premium%20result%20quality%20workmanship%20photography&width=600&height=760&seq=abtval02&orientation=portrait',
    title: 'Proven Experience',
    description: 'Over two decades of hands-on experience installing polished concrete and decorative finishes for residential and commercial clients across the upper Midwest.',
    href: '/about',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=architect%20contractor%20reviewing%20completed%20polished%20concrete%20floor%20finish%20modern%20building%20project%20professional%20collaboration%20satisfaction%20premium%20result%20inspection%20photography&width=600&height=880&seq=abtval03&orientation=portrait',
    title: 'Trusted Partners',
    description: 'We work closely with contractors, architects, and property owners to deliver results that align with vision, budget, and timeline on every project.',
    href: '/about',
  },
];

const aboutQAs = [
  {
    question: 'When was Polished Concrete Plus founded?',
    answer: 'The company was founded in 2003 under the name Polished Concrete Images. In 2011, it was rebranded to Polished Concrete Plus to reflect expansion into a wider range of materials, techniques, and specialized decorative concrete services across the upper Midwest region.',
  },
  {
    question: 'Where is Polished Concrete Plus headquartered?',
    answer: 'The company is headquartered in Sauk Rapids, Minnesota, with a mailing address at 15076 15th Ave NW, Rice, MN 56367. We serve all of Minnesota and travel into Iowa, Wisconsin, North Dakota, and South Dakota for qualified commercial and residential projects.',
  },
  {
    question: 'What makes Polished Concrete Plus different from others?',
    answer: 'We combine 20+ years of certified experience with a genuine commitment to quality — using industrial-grade systems on every project, residential or commercial. Our certified concrete construction managers bring both technical mastery and on-site professionalism to every job.',
  },
  {
    question: 'Who are the people behind Polished Concrete Plus?',
    answer: 'The primary contact is Jeff Kasella, reachable at 320.493.1454 or josh@polishedconcreteplus.com. The team consists of certified concrete construction managers with deep expertise in polished concrete and all major decorative surface systems available today.',
  },
];

const aboutSteps = [
  { number: '2003', title: 'Company Founded', description: 'Established as Polished Concrete Images in Minnesota, focused on polished concrete installation for residential and commercial clients.', icon: 'ri-flag-line' },
  { number: '2005', title: 'Regional Growth', description: 'Expanded service reach across greater Minnesota, taking on larger residential and commercial projects and building a strong referral network.', icon: 'ri-map-pin-line' },
  { number: '2011', title: 'Rebrand & Expansion', description: 'Renamed to Polished Concrete Plus and expanded into floor coatings, terrazzo, custom graphics, and concrete restoration services.', icon: 'ri-rocket-line' },
  { number: '2015', title: 'Multi-State Reach', description: 'Extended service territory to Iowa, Wisconsin, North Dakota, and South Dakota for qualified commercial and residential projects.', icon: 'ri-global-line' },
  { number: 'Today', title: '20+ Years Strong', description: 'Serving the upper Midwest as the premier certified polished concrete and decorative surface installer with two decades of proven results.', icon: 'ri-trophy-line' },
];

const aboutReasons = [
  {
    icon: 'ri-user-star-fill',
    title: 'Our Mission',
    points: [
      'Deliver premium surface finishing to every client',
      'Bring quality and lasting value to every project',
      'Treat every floor — large or small — with equal care',
      'Maintain long-term client relationships through trust',
    ],
  },
  {
    icon: 'ri-microscope-fill',
    title: 'Our Expertise',
    points: [
      'Certified concrete construction managers on every job',
      'Deep expertise in restoring 50-year-old concrete',
      'Polished concrete to full industrial coating systems',
      'Custom terrazzo and embedded decorative graphics',
    ],
  },
  {
    icon: 'ri-heart-3-fill',
    title: 'Our Values',
    points: [
      'Transparency from estimate through project completion',
      'We recommend what\'s right — no upselling',
      'Clean, professional job sites every time',
      'Free consultations — we earn your business honestly',
    ],
  },
];

const aboutAreas = [
  { state: 'Minnesota (Primary)', cities: ['Minneapolis', 'St. Paul', 'Duluth', 'Rochester', 'St. Cloud', 'Moorhead', 'Sauk Rapids', 'Rice'] },
  { state: 'Regional Service', cities: ['Iowa', 'Wisconsin', 'North Dakota', 'South Dakota'] },
];

const aboutFAQs = [
  {
    question: 'How long has Polished Concrete Plus been in business?',
    answer: 'Polished Concrete Plus has been installing polished concrete and decorative finishes since 2003 — over 20 years. The company began as Polished Concrete Images and rebranded in 2011 to reflect its expanded range of services and growing regional expertise across the upper Midwest.',
  },
  {
    question: 'Is Polished Concrete Plus licensed and certified?',
    answer: 'Yes. Polished Concrete Plus employs certified concrete construction managers with the expertise to handle residential, commercial, and industrial projects to the highest professional standards in Minnesota and surrounding states. Every project receives a certified installer.',
  },
  {
    question: 'Does Polished Concrete Plus do residential work or only commercial?',
    answer: 'Both. We have installed polished concrete in brand-new residential homes and remodeled projects with 50-year-old concrete, as well as large commercial facilities, retail spaces, and industrial floors throughout Minnesota and the surrounding upper Midwest region.',
  },
  {
    question: 'How do I get in touch with Polished Concrete Plus?',
    answer: 'Reach Jeff Kasella directly at 320.493.1454 or email josh@polishedconcreteplus.com. Our address is 15076 15th Ave NW, Rice, MN 56367. We offer free consultations and on-site estimates for all projects across Minnesota and surrounding states — no obligation.',
  },
  {
    question: 'What states does Polished Concrete Plus serve?',
    answer: 'Polished Concrete Plus is headquartered in Sauk Rapids, Minnesota, and serves all of Minnesota — plus Iowa, Wisconsin, North Dakota, and South Dakota for qualified residential and commercial projects. Call 320.493.1454 to discuss your specific project location.',
  },
];

export default function AboutPage() {
  return (
    <main>
      <Navbar />

      <HeroSection
        backgroundImage="https://readdy.ai/api/search-image?query=professional%20skilled%20craftsman%20using%20large%20diamond%20grinding%20machine%20on%20polished%20concrete%20floor%20commercial%20building%20interior%20dramatic%20side%20lighting%20industrial%20atmosphere%20rich%20shadows%20premium%20cinematic%20photography%20workmanship&width=1920&height=1080&seq=abthero01&orientation=landscape"
        eyebrow="Our Story — Polished Concrete Plus"
        headline="Minnesota's Premier"
        headlineAccent="Concrete Specialists Since 2003."
        subheadline="From a focused polishing operation in 2003 to a full-service decorative concrete company — Polished Concrete Plus has built its reputation on craftsmanship, integrity, and results across the upper Midwest."
        ctaText="Get a Free Estimate"
        ctaHref="#contact"
        secondaryCtaText="View Our Services"
        secondaryCtaHref="/services"
      />

      <TrustBar items={aboutTrustItems} />

      <ServicesOverview
        eyebrow="What We Stand For"
        headline="Built on Craftsmanship & Integrity"
        subheadline="The core values that define every project we take on — from a single-room floor to a large-scale commercial facility."
        services={aboutValues}
        ctaLabel="See All Services"
        ctaHref="/services"
      />

      <AIAnswerBlock
        eyebrow="About the Company — Clear Answers"
        headline="Who Is Polished Concrete Plus?"
        intro="Everything you should know about our history, people, and approach to decorative concrete finishing in Minnesota and the upper Midwest."
        qas={aboutQAs}
      />

      <ProcessSection
        eyebrow="Our Journey"
        headline="20 Years of Growth & Excellence"
        steps={aboutSteps}
      />

      <WhyChooseUsSection
        eyebrow="Our Commitment to You"
        headline="Mission, Expertise & Values"
        subheadline="We believe every floor deserves the same level of care and craftsmanship — regardless of size, budget, or age of the concrete."
        reasons={aboutReasons}
        backgroundImage="https://readdy.ai/api/search-image?query=beautiful%20ultra%20reflective%20polished%20concrete%20floor%20in%20large%20commercial%20space%20dramatic%20overhead%20lighting%20dramatic%20warm%20glow%20wide%20angle%20perspective%20architectural%20photography%20deep%20shadows%20premium%20finish&width=900&height=1100&seq=abtwhy01&orientation=portrait"
      />

      <ServiceAreasSection
        eyebrow="Where We Work"
        headline="Serving the Upper Midwest"
        subheadline="Headquartered in Sauk Rapids, MN — available for projects throughout Minnesota and into neighboring states."
        areas={aboutAreas}
        showMap
      />

      <SocialProofSection />

      <FAQSection
        eyebrow="About Us — FAQs"
        headline="Questions About Our Company"
        faqs={aboutFAQs}
      />

      <FinalCTASection
        headline="Work With Minnesota's Best"
        subheadline="20 years of certified expertise. Free consultations. Projects done right the first time. Reach out today and let's discuss your project."
        backgroundImage="https://readdy.ai/api/search-image?query=modern%20elegant%20residential%20home%20interior%20evening%20lighting%20polished%20concrete%20floor%20glowing%20warm%20amber%20living%20space%20beautiful%20architectural%20design%20photography%20premium%20lifestyle&width=1920&height=1080&seq=abtcta01&orientation=landscape"
      />

      <Footer />
    </main>
  );
}
